/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Detail_Export_DocxInputs */

const en_cover_letters_detail_export_docx = /** @type {(inputs: Cover_Letters_Detail_Export_DocxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export DOCX`)
};

const de_cover_letters_detail_export_docx = /** @type {(inputs: Cover_Letters_Detail_Export_DocxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX exportieren`)
};

const fr_cover_letters_detail_export_docx = /** @type {(inputs: Cover_Letters_Detail_Export_DocxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter en DOCX`)
};

const es_cover_letters_detail_export_docx = /** @type {(inputs: Cover_Letters_Detail_Export_DocxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar DOCX`)
};

const it_cover_letters_detail_export_docx = /** @type {(inputs: Cover_Letters_Detail_Export_DocxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta DOCX`)
};

const nl_cover_letters_detail_export_docx = /** @type {(inputs: Cover_Letters_Detail_Export_DocxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporteer DOCX`)
};

const pl_cover_letters_detail_export_docx = /** @type {(inputs: Cover_Letters_Detail_Export_DocxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksportuj DOCX`)
};

const fi_cover_letters_detail_export_docx = /** @type {(inputs: Cover_Letters_Detail_Export_DocxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vie DOCX`)
};

const da_cover_letters_detail_export_docx = /** @type {(inputs: Cover_Letters_Detail_Export_DocxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksporter DOCX`)
};

const sv_cover_letters_detail_export_docx = /** @type {(inputs: Cover_Letters_Detail_Export_DocxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportera DOCX`)
};

/**
* | output |
* | --- |
* | "Export DOCX" |
*
* @param {Cover_Letters_Detail_Export_DocxInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_detail_export_docx = /** @type {((inputs?: Cover_Letters_Detail_Export_DocxInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Detail_Export_DocxInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_detail_export_docx(inputs)
	if (locale === "fr") return fr_cover_letters_detail_export_docx(inputs)
	if (locale === "es") return es_cover_letters_detail_export_docx(inputs)
	if (locale === "it") return it_cover_letters_detail_export_docx(inputs)
	if (locale === "nl") return nl_cover_letters_detail_export_docx(inputs)
	if (locale === "pl") return pl_cover_letters_detail_export_docx(inputs)
	if (locale === "fi") return fi_cover_letters_detail_export_docx(inputs)
	if (locale === "da") return da_cover_letters_detail_export_docx(inputs)
	if (locale === "sv") return sv_cover_letters_detail_export_docx(inputs)
	return en_cover_letters_detail_export_docx(inputs)
});